import type { SettingsSection, SettingsMenuItem } from './settings/settingsMenuItem'

export const matchesQuery = (value: string, query: string) => {
  if (!value) return false
  const lowerQuery = query.toLowerCase()
  return value.toLowerCase().includes(lowerQuery)
}

export const filterSectionsBySearch = (sections: SettingsSection[], searchQuery: string) => {
  if (searchQuery.trim() === '') return sections
  const lowerQuery = searchQuery.trim().toLowerCase()
  return sections
    .map((section) => {
      const sectionTitleMatches = matchesQuery(section.title, lowerQuery)
      if (sectionTitleMatches) {
        return section
      }
      const filteredItems = section.items.filter((item: SettingsMenuItem) => matchesQuery(item.label, lowerQuery))
      return { ...section, items: filteredItems }
    })
    .filter((section) => section.items.length > 0 || matchesQuery(section.title, lowerQuery))
}
